var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.6739V17.4045C0 17.7333 0.266508 18 0.595282 18H3.33092C3.4888 18 3.64022 17.9372 3.75186 17.8256L15 6.57364L11.4275 3L0.17443 14.2526C0.0627428 14.3643 0 14.5158 0 14.6739Z",
    fill: "#00406A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.21261L15.7873 6L17.6303 4.15675C18.1232 3.6638 18.1232 2.86456 17.6303 2.37161L15.6286 0.369714C15.1357 -0.123173 14.3366 -0.123249 13.8437 0.36955L12 2.21261Z",
    fill: "#00406A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1d465b41532a127272eebc8fe85eeb7e.svg";
export { ForwardRef as ReactComponent };